import { render, staticRenderFns } from "./PrescriptionInfo.vue?vue&type=template&id=03d02a26&scoped=true&"
import script from "./PrescriptionInfo.vue?vue&type=script&lang=js&"
export * from "./PrescriptionInfo.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionInfo.vue?vue&type=style&index=0&id=03d02a26&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d02a26",
  null
  
)

export default component.exports